"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCapabilityAvailable = exports.isTypeEligible = void 0;
const capabilityCatalog_1 = require("./capabilityCatalog");
const enums_1 = require("./contracts/enums");
/**
 * Whether a registry type is in a capability's `appliesTo` set. Security follows the company
 * baseline unless the set lists `security` explicitly.
 */
const isTypeEligible = (appliesTo, type) => {
    if (appliesTo.includes(type)) {
        return true;
    }
    if (type === enums_1.RegistryType.Security &&
        !appliesTo.includes(enums_1.RegistryType.Security) &&
        appliesTo.includes(enums_1.RegistryType.Company)) {
        return true;
    }
    return false;
};
exports.isTypeEligible = isTypeEligible;
/** Unknown ids fail closed. `type` must already be the effective registry type (unset → company). */
const isCapabilityAvailable = (id, type) => {
    const definition = (0, capabilityCatalog_1.getCapabilityDefinition)(id);
    if (!definition) {
        return false;
    }
    return (0, exports.isTypeEligible)(definition.appliesTo, type);
};
exports.isCapabilityAvailable = isCapabilityAvailable;
//# sourceMappingURL=capabilityEligibility.js.map